import { Typography } from "antd";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, Title, Tooltip, Legend, CategoryScale, LinearScale } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";

// Register necessary components
ChartJS.register(BarElement, Title, Tooltip, Legend, CategoryScale, LinearScale);

export default function AreaCostos({ labels, data, colors, groupBy }) {
  const formatAbbreviated = (value) => {
    if (!value) return "0";
    if (value >= 1000000) return (value / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    if (value >= 1000) return (value / 1000).toFixed(1).replace(/\.0$/, "") + "k";
    return Math.round(value);
  };

  const formatCurrency = (value) => 
    new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      maximumFractionDigits: 0,
    }).format(value);

  const formattedLabels = labels.map((label) => {
    if (typeof label !== 'string') return label;
    // Abbreviate dates consistently with LineChart
    if (label.includes('-SEM')) return label.split('-')[1]; // Keep SEMXX
    const parts = label.split('-');
    if (parts.length === 3) return `${parts[1]}-${parts[2]}`; // Keep MM-DD
    if (parts.length === 2) return parts[1]; // Keep MM
    return label;
  });

  const chartData = {
    labels: formattedLabels,
    datasets: [
      {
        label: "Monto",
        data,
        backgroundColor: colors[0] + "80", // Semi-transparent
        borderColor: colors[0],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `Total: ${formatCurrency(context.parsed.y)}`
        }
      },
      datalabels: {
        anchor: "end",
        align: "top",
        offset: 2,
        rotation: -90,
        font: { size: 10, weight: "bold" },
        color: "#595959",
        formatter: formatAbbreviated,
        display: (context) => context.dataset.data[context.dataIndex] > 0
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: formatAbbreviated,
          font: { size: 10 }
        }
      },
      x: {
        grid: { display: false },
        ticks: { font: { size: 10 } }
      }
    },
    layout: {
      padding: { top: 40 }
    }
  };

  return (
    <div style={{ height: "300px" }}>
      {data ? (
        <Bar 
          data={chartData} 
          options={options} 
          plugins={[ChartDataLabels]} 
        />
      ) : (
        <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Typography.Text type="secondary">Cargando datos...</Typography.Text>
        </div>
      )}
    </div>
  );
}
